const AUTH_KEY = 'authToken';
const CAN_ACCESS_KEY = 'canAccessIds';
const POST_LOGIN_REDIRECT_KEY = 'postLoginRedirect';

const getAuthToken = () => {
  const fromLocal = localStorage.getItem(AUTH_KEY);
  if (fromLocal) return fromLocal;

  // Migrate legacy tab-scoped sessions so new tabs (e.g. email links) can reuse login
  const fromSession = sessionStorage.getItem(AUTH_KEY);
  if (fromSession) {
    localStorage.setItem(AUTH_KEY, fromSession);
    sessionStorage.removeItem(AUTH_KEY);
    return fromSession;
  }
  return null;
};

const setAuthToken = token => {
  localStorage.setItem(AUTH_KEY, token);
  sessionStorage.removeItem(AUTH_KEY);
};

const clearAuthToken = () => {
  localStorage.removeItem(AUTH_KEY);
  sessionStorage.removeItem(AUTH_KEY);
  sessionStorage.removeItem(CAN_ACCESS_KEY);
  localStorage.removeItem(CAN_ACCESS_KEY);
};

const getSafeReturnUrl = value => {
  if (!value || typeof value !== 'string') return '/';

  let url = value.trim();
  try {
    // Router / redirect flows can leave the value still encoded
    if (url.includes('%') && !url.startsWith('/')) {
      const decoded = decodeURIComponent(url);
      if (decoded.startsWith('/')) url = decoded;
    }
  } catch (err) {
    return '/';
  }

  if (!url.startsWith('/') || url.startsWith('//')) return '/';

  const path = url.split(/[?#]/)[0];
  const blockedPaths = [
    '/login',
    '/feedback/login',
    '/feedback/response',
    '/response',
    '/response-confirmation'
  ];
  if (blockedPaths.some(blocked => path === blocked || path.startsWith(`${blocked}/`))) {
    return '/';
  }

  return url;
};

const stripOAuthParams = url => {
  try {
    const parsed = new URL(url, 'http://localhost');
    ['code', 'session_state', 'state', 'error', 'error_description'].forEach(param => {
      parsed.searchParams.delete(param);
    });
    const search = parsed.searchParams.toString();
    return `${parsed.pathname}${search ? `?${search}` : ''}${parsed.hash}`;
  } catch (err) {
    return url;
  }
};

const savePostLoginRedirect = returnUrl => {
  const safeUrl = stripOAuthParams(getSafeReturnUrl(returnUrl));
  // localStorage survives OAuth round-trips more reliably than sessionStorage
  localStorage.setItem(POST_LOGIN_REDIRECT_KEY, safeUrl);
  sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
};

const peekPostLoginRedirect = () => {
  const value =
    localStorage.getItem(POST_LOGIN_REDIRECT_KEY) ||
    sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
  return stripOAuthParams(getSafeReturnUrl(value));
};

const consumePostLoginRedirect = () => {
  const returnUrl = peekPostLoginRedirect();
  localStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
  sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
  return returnUrl;
};

export const authStorage = {
  AUTH_KEY,
  getAuthToken,
  setAuthToken,
  clearAuthToken,
  getSafeReturnUrl,
  savePostLoginRedirect,
  consumePostLoginRedirect,
  peekPostLoginRedirect
};
